module.exports = __webpack_public_path__ + "media/images/icon_nav_category_white-81ab721ae889766f40472e290fd66d02.svg";